import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b362cd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "border border-2 border-lightgray position-relative container-area",
  style: {"height":"100%","width":"100%"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]

import {
  onUpdated,
  onMounted,
  watch,
  ref,
} from "vue";


const __default__ = {
  name: "AreaofInterest",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  imgSrc: {
    type: String,
  },
  name: {
    type: String,
  },
  drawedRectangles: {
    type: String,
    default: "",
  },
},
  emits: ["change-areas"],
  setup(__props, { emit }) {

const props = __props;




let areasOfInterest = [];
let rectangles = [];
let currentRect = null;

function sendAreasOfInterest() {
  const canvas = document.getElementById(props.name);
  const img = document.querySelector(".img-responsive");
  const scaleFactorY =
    img.naturalHeight / canvas.getBoundingClientRect().height;
  const scaleFactorX = img.naturalWidth / canvas.getBoundingClientRect().width;

  areasOfInterest = rectangles.map((rect) => {
    return {
      x1: parseInt(rect.x * scaleFactorX),
      y1: parseInt(rect.y * scaleFactorY),
      x2: parseInt((rect.x + rect.width) * scaleFactorX),
      y2: parseInt((rect.y + rect.height) * scaleFactorY),
    };
  });
  emit("change-areas", areasOfInterest);
}

onMounted(async () => {
  const img = document.querySelector(".img-responsive");
  const container = document.querySelector(".container-area");
  container.style.height = `${
    container.clientWidth * (img.naturalHeight / img.naturalWidth)
  }px`;
  const canvas = document.querySelector(".canvas-responsive");
  canvas.width = img.clientWidth;
  canvas.height = img.clientHeight;
  if (props.drawedRectangles) {
    const scaleFactorY =
      img.naturalHeight / canvas.getBoundingClientRect().height;
    const scaleFactorX =
      img.naturalWidth / canvas.getBoundingClientRect().width;
    rectangles = JSON.parse(props.drawedRectangles).map((item) => {
      return {
        id: Date.now() + item.x1,
        x: item.x1 / scaleFactorX,
        y: item.y1 / scaleFactorY,
        width: (item.x2 - item.x1) / scaleFactorX,
        height: (item.y2 - item.y1) / scaleFactorY,
      };
    });
    onMouseUp();
  }
});

onUpdated(() => {
  const img = document.querySelector(".img-responsive");
  const container = document.querySelector(".container-area");
  container.style.height = `${
    container.clientWidth * (img.naturalHeight / img.naturalWidth)
  }px`;

  const canvas = document.querySelector(".canvas-responsive");
  canvas.width = img.clientWidth;
  canvas.height = img.clientHeight;
});

const imageRef = ref();

watch(
  () => imageRef.value,
  (newVal, oldVal) => {
    if (newVal !== oldVal) {
      const img = document.querySelector(".img-responsive");
      const container = document.querySelector(".container-area");
      img.onload = () => {
        container.style.height = `${
          container.clientWidth * (img.naturalHeight / img.naturalWidth)
        }px`;
        const canvas = document.querySelector(".canvas-responsive");
        canvas.width = img.clientWidth;
        canvas.height = img.clientHeight;
      };
    }
  }
);

function onMouseDown(event) {
  // Get the position of the click within the canvas element.
  const canvas = document.getElementById(props.name);
  const rect = canvas.getBoundingClientRect();
  const x = parseInt(event.clientX - rect.left);
  const y = parseInt(event.clientY - rect.top);

  // Create a new rectangle and set its initial position.
  const newRect = {
    id: Date.now(),
    x: x,
    y: y,
    width: 0,
    height: 0,
  };
  currentRect = newRect;
  rectangles.push(newRect);
}

function onMouseMove(event) {
  // If we are not currently drawing a rectangle, do nothing.
  if (!currentRect) {
    return;
  }
  // Get the current position of the mouse within the canvas element.
  const canvas = document.getElementById(props.name);
  const rect = canvas.getBoundingClientRect();
  const x = parseInt(event.clientX - rect.left);
  const y = parseInt(event.clientY - rect.top);

  // Update the width and height of the current rectangle.
  currentRect.width = x - currentRect.x;
  currentRect.height = y - currentRect.y;

  // Redraw all the rectangles.
  drawRectangles();
}

function onMouseUp(event) {
  const rectsDiv = document.getElementById("rectanglesDiv" + props.name);
  rectsDiv.innerHTML = "";
  for (const rect of rectangles) {
    createHTMLelement(rect);
  }
  // Reset the current rectangle.
  currentRect = null;
  sendAreasOfInterest();
}

function drawRectangles() {
  const canvas = document.getElementById(props.name);
  const ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  for (const rect of rectangles) {
    ctx.fillStyle = "rgba(255, 255, 255, 0.05)";
    ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
    ctx.strokeStyle = "#ff0000";
    ctx.setLineDash([6]);
    ctx.strokeRect(rect.x, rect.y, rect.width, rect.height);
  }
}

function createHTMLelement(rect) {
  const canvas = document.getElementById(props.name);
  const ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  const deleteButton = document.createElement("button");
  deleteButton.classList.add("btn");
  deleteButton.classList.add("btn-transparent");
  deleteButton.classList.add("p-0");
  deleteButton.classList.add("position-absolute");
  deleteButton.style.cursor = "pointer";
  deleteButton.style.top = "-25px";
  deleteButton.style.right = "-15px";
  deleteButton.innerHTML =
    '<i class="fa fa-trash text-danger" aria-hidden="true"></i>';

  deleteButton.addEventListener("click", () => {
    const id = parseInt(deleteButton.parentElement.getAttribute("dataId"));
    rectangles = rectangles.filter((rect) => rect.id !== id);
    onMouseUp();
  });

  if (rect.width < 0) {
    rect.width = rect.width * -1;
    rect.x = rect.x - currentRect.width;
  }
  if (rect.height < 0) {
    rect.height = rect.height * -1;
    rect.y = rect.y - rect.height;
  }

  const r = document.createElement("div");
  r.setAttribute("dataId", rect.id);
  r.classList.add("position-absolute");
  r.classList.add("border");
  r.classList.add("border-1");
  r.classList.add("border-danger");
  r.style.width = rect.width + "px";
  r.style.height = rect.height + "px";
  r.style.top = rect.y + "px";
  r.style.left = rect.x + "px";
  r.style.backgroundColor = "rgba(255, 255, 255, 0.15)";
  r.appendChild(deleteButton);

  const rectsDiv = document.getElementById("rectanglesDiv" + props.name);
  rectsDiv.appendChild(r);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: __props.imgSrc,
      ref_key: "imageRef",
      ref: imageRef,
      class: "z-index-0 position-absolute img-responsive",
      draggable: "false",
      style: {"width":"100%","height":"100%","object-fit":"contain"}
    }, null, 8, _hoisted_2),
    _createElementVNode("canvas", {
      class: "z-index-3 position-absolute canvas-responsive",
      id: __props.name,
      viewBox: "0 0 920 600",
      style: {"top":"0","left":"0"},
      onMousedown: onMouseDown,
      onMousemove: onMouseMove,
      onMouseup: onMouseUp
    }, null, 40, _hoisted_3),
    _createElementVNode("div", {
      id: 'rectanglesDiv' + __props.name,
      class: "bg-transparent rectangles-div position-absolute z-index-3"
    }, null, 8, _hoisted_4)
  ]))
}
}

})